import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom'
import HomeHeader from 'components/HomePageHeader'
import Footer from 'components/Footer'
import { ErrorBox } from 'components/ErrorBox/ErrorBox'
import { createCommunitySsoToken } from 'services/community'
import styles from './CommunitySso.module.css'

// The community keeps the sign-in only when the token arrives in a top-level form POST, not through fetch
const postToCommunity = (callbackUrl, fields) => {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = callbackUrl
  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  })
  document.body.appendChild(form)
  form.submit()
}

const CommunitySso = () => {
  const history = useHistory()
  const { search } = useLocation()
  const [failed, setFailed] = useState(false)

  // Every way of signing in ends at redirect-url, which brings the person back here with the same return_to
  const signIn = () => {
    localStorage.removeItem('token')
    localStorage.setItem('redirect-url', window.location.href)
    history.replace('/login')
  }

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      signIn()
      return
    }
    // Present only on links from tiiny.host; the community's own button sends none, so it reopens the remembered page
    const returnTo = new URLSearchParams(search).get('return_to')
    createCommunitySsoToken(returnTo)
      .then(({ data }) =>
        postToCommunity(data.callbackUrl, { token: data.token, ...(data.returnTo && { return_to: data.returnTo }) })
      )
      // The server answers 403 to a session it no longer accepts; any other failure stays on screen, so it can't loop via /login
      .catch((err) => (err.response?.status === 403 ? signIn() : setFailed(true)))
  }, [])

  return (
    <div className="body-bg full-height">
      <HomeHeader logoOnly />
      <div className={styles.page}>
        {failed ? (
          <ErrorBox message="We couldn't sign you in to the community.<br />Go back and try again." hideButton />
        ) : (
          <>
            <Spinner animation="border" />
            <p className="op-6 mt-3">Signing you in to the community…</p>
          </>
        )}
      </div>
      <Footer simplified />
    </div>
  )
}

export default CommunitySso
